export default __webpack_public_path__ + "static/media/template_business-man__0018_9---RobYong.c7b0ae18.png";